import { Tab, TabList, TabPanel, TabPanels, Tabs, useBreakpointValue } from '@chakra-ui/react';
import { useReferralContext } from 'hooks/useReferralContext';
import { Login } from './Login';
import { Register } from './Register';
import('react-phone-number-input/style.css');

function Root() {
  const tabVariant = useBreakpointValue({ base: 'soft-rounded', md: 'enclosed' });
  // Couvre les 2 formats de lien (`?campaign=&clientId=` nouveau + `?referral=<base64>`
  // legacy) — pré-sélectionne l'onglet "S'inscrire" dans les deux cas.
  const { hasReferral } = useReferralContext();
  return (
    <Tabs isFitted={tabVariant === 'soft-rounded'} align="center" defaultIndex={hasReferral ? 1 : 0}>
      <TabList mb="1em">
        <Tab>Se connecter</Tab>
        <Tab>S'inscrire</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Firebase.Login />
        </TabPanel>
        <TabPanel>
          <Firebase.Register />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}

export const Firebase = Object.assign(Root, { Login, Register });
